// frontend/src/pages/AuthCallback.jsx
import { useEffect, useContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

// tiny helper; you can use qs, query-string, or URLSearchParams
const getTokenFromSearch = (search) => {
  const params = new URLSearchParams(search);
  return params.get('token');
};

function AuthCallback() {
  const { login, isAuthenticated, authLoading, user } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [hasProcessedToken, setHasProcessedToken] = useState(false);

  // Get the page the user was trying to access, or default to profile
  const from = location.state?.from?.pathname || '/profile';

  // Process token on mount
  useEffect(() => {
    const token = getTokenFromSearch(location.search);

    if (token && !hasProcessedToken) {
      setHasProcessedToken(true);
      login(token);
    } else if (!token) {
      // Something's wrong – punt them to the login screen
      navigate('/login');
    }
  }, [location.search, login, hasProcessedToken, navigate]);

  // Redirect after successful login and user data is loaded
  useEffect(() => {
    if (hasProcessedToken && !authLoading && isAuthenticated && user) {
      // User is now logged in and data is loaded, navigate to original page
      navigate(from, { replace: true });
    }
  }, [hasProcessedToken, authLoading, isAuthenticated, user, navigate, from]);

  return <p className="text-center mt-40">Signing you in…</p>;
}

export default AuthCallback;
